import { AppId } from '@lumapps/constants/app';
import { createPageRoute, Route } from '@lumapps/router';

export const learningEventsRoute: Route = createPageRoute({
    slug: 'learning/catalog/events',
    appId: AppId.backOffice,
});

export const learningSpeakersRoute: Route = createPageRoute({
    slug: 'learning/role-settings/speakers',
    appId: AppId.backOffice,
});
